import React, { Component } from 'react';
import MarkupConversion from '../../../Components/MarkupConversion';
import http from '../../../services/http';
import ProfileService from '../../../services/ProfileService';
import { conditionRulesChecking, isSet } from '../../../Utils/CommonFunctions';
import {
  buildPagesConfigExecutePayload,
  buildPagesRouteQuery,
  normalizeAutomationOutputValue,
  buildPagesRedirectFieldOutputs,
  normalizePagesGetRatesRedirectOutputs,
  wrapPagesConfigExecutePayload,
  evaluatePagesMessageCondition,
  orderToPageMappingForExecute,
  isEffectiveSamePageResult,
  resolveSamePageHostConfig,
  resolveIsSamePageAutomation,
  resolveAndNavigateRedirect,
  isToPageRedirectMode,
  resolveMappedVariableValue,
  resolvePagesHttpErrorMessage,
} from '../PagesContainerUtils';
import {
  buildMergedPagesExecuteParams,
  flattenFormPayloadForPagesExecute,
  isLikelyCountryCodeNotPostal,
  isPagesPostalVariableKey,
} from "../pagesAutomationUtils";
import {
  buildPagesRateWithShipmentsFromOutputResponse,
  ensureGetRatesMarkupOutputResponse,
  persistGetRatesExecuteResponse,
  omitEphemeralPagesParams,
  resolvePagesRedirectTargetConfigApiName,
  resolvePagesTargetConfigKey,
  isGetRatesPageRedirectTarget,
  collectRatesResultsPageDataKeys,
  mergeSamePageExecuteOutputs,
  applyMappedExecuteOutputsToParams,
} from '../getRatesPagesUtils';
import { isRatesResultsConfig } from '../pagesFeatureConfig';
import {
  hasPagesInlineFieldErrors,
} from '../pagesValidationUtils';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions';
import { setErrorListAction } from '../../../store/actions/ErrorSetupAction';
import {
  loadPageConfigCollectionAction,
  removeActivePopupPageAction,
  updatePageFlowsDataAction,
  setPagesHistoryConfigAction,
  updatePageDataByKeyAction,
  resetPagesRuntimeCacheAction,
} from '../../../store/actions/PagesAction';
import BackgroundActionInputModal from '../../LayoutContainer/BackgroundActionInputModal';
import { createPortal } from 'react-dom';
class PagesRenderComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
        formPayload:{},
        isbackgroundProcess:false,
        toEmail: null,
        reminderAlert: null,
        pendingAutomation: null
    };
  }
  wrapperDom = document.querySelector('.wrapper');

  // Validation feedback is inline (*_error under fields). Do not toast.
  emitPagesValidationFeedback = () => {};

  runPageAction = (actionApiName, spec = {}) => {
    const action = actionApiName != null ? String(actionApiName).trim() : "";
    if (!action) {
      return;
    }
    this.onSubmitAutomationHandler(action);
  };

  hasNonEmptyPagesRuntimeValue = (raw) => {
    const value = normalizeAutomationOutputValue("", raw);
    return !(
      value === null ||
      value === undefined ||
      (typeof value === "string" && value.trim() === "") ||
      (Array.isArray(value) && value.length === 0)
    );
  };

  syncOutputResponseToFormPayload = (outputResponse = {}) => {
    if (!outputResponse || typeof outputResponse !== "object") {
      this.setState((prev) =>
        prev.formPayload && Object.keys(prev.formPayload).length > 0
          ? { formPayload: {} }
          : null
      );
      return;
    }

    const hasResponseValues = Object.values(outputResponse).some((raw) =>
      this.hasNonEmptyPagesRuntimeValue(raw)
    );
    if (!hasResponseValues) {
      this.setState((prev) =>
        prev.formPayload && Object.keys(prev.formPayload).length > 0
          ? { formPayload: {} }
          : null
      );
      return;
    }

    this.setState((prev) => {
      const next = { ...prev.formPayload };
      let changed = false;

      Object.entries(outputResponse).forEach(([key, raw]) => {
        const value = normalizeAutomationOutputValue(key, raw);
        const keyLower = String(key || "").toLowerCase();
        const isPackageKey =
          keyLower === "package" ||
          keyLower === "packages" ||
          keyLower === "package_out";

        const hasValue = !(
          value === null ||
          value === undefined ||
          (typeof value === "string" && value.trim() === "") ||
          (Array.isArray(value) && value.length === 0)
        );
        // Explicit mapped empty array/string must clear prior form value
        // (same-page re-execute). Do not skip just because empty.
        if (!hasValue) {
          if (
            Object.prototype.hasOwnProperty.call(outputResponse, key) &&
            (Array.isArray(value) || value === "")
          ) {
            next[key] = {
              ...(next[key] || {}),
              api_name: key,
              selected_value: Array.isArray(value) ? [] : "",
            };
            changed = true;
          }
          return;
        }

        // Do not let automation/shipObj echo replace a real postal with ISO country (CA).
        if (isPagesPostalVariableKey(key) && isLikelyCountryCodeNotPostal(value)) {
          const existing = next[key]?.selected_value;
          if (
            existing != null &&
            String(existing).trim() !== "" &&
            !isLikelyCountryCodeNotPostal(existing)
          ) {
            return;
          }
        }
        if (isPackageKey && Array.isArray(value)) {
          const existingRows = Array.isArray(next[key]?.selected_value)
            ? next[key].selected_value
            : [];
          const existingRich = existingRows.some(
            (row) =>
              row &&
              typeof row === "object" &&
              ((row.cf_packages != null &&
                typeof row.cf_packages === "object" &&
                !Array.isArray(row.cf_packages)) ||
                (row.cf_description != null &&
                  String(row.cf_description).trim() !== "") ||
                (row.description != null &&
                  String(row.description).trim() !== ""))
          );
          const incomingRich = value.some(
            (row) =>
              row &&
              typeof row === "object" &&
              ((row.cf_packages != null &&
                typeof row.cf_packages === "object" &&
                !Array.isArray(row.cf_packages)) ||
                (row.cf_description != null &&
                  String(row.cf_description).trim() !== "") ||
                (row.description != null &&
                  String(row.description).trim() !== ""))
          );
          // Keep rich Package rows; do not let slim Get Rates Package_out wipe them.
          // Rich→rich (new same-page execute) still replaces.
          if (existingRich && !incomingRich) {
            return;
          }
          // Keep live form dims; do not let blank package rows wipe weight/L/W/H.
          const existingHasDims = existingRows.some(
            (row) =>
              row &&
              typeof row === "object" &&
              ["weight", "length", "width", "height"].some(
                (k) => row[k] != null && String(row[k]).trim() !== ""
              )
          );
          const incomingHasDims = value.some(
            (row) =>
              row &&
              typeof row === "object" &&
              ["weight", "length", "width", "height"].some(
                (k) => row[k] != null && String(row[k]).trim() !== ""
              )
          );
          if (existingHasDims && !incomingHasDims) {
            return;
          }
        }

        next[key] = {
          ...(next[key] || {}),
          api_name: key,
          selected_value: value
        };
        // HTML subform is name="Package"; pages var/api are Packages/packages.
        // Mirror all casing aliases so Edit DIRECT seed fills the visible table.
        if (isPackageKey && Array.isArray(value)) {
          ["Package", "Packages", "package", "packages"].forEach((alias) => {
            if (alias === key) {
              return;
            }
            next[alias] = {
              ...(next[alias] || {}),
              api_name: alias,
              selected_value: value,
            };
          });
        }
        changed = true;
      });

      return changed ? { formPayload: next } : null;
    });
  }

  getPublicPagesContext = () => {
    const params = new URLSearchParams(window.location.search);
    const isPublic = params.get('public') === 'true';
    const domainName = params.get('domain') || 'apps.myship.ca';
    return { isPublic, domainName };
  }
  getPublicPagesQuery = () => {
    // Includes public/domain + org_window_id (left-nav orange identity)
    return buildPagesRouteQuery();
  }
  getPagesWindowQuery = () => buildPagesRouteQuery({ mode: 'window' });
  getExecuteUrl = (automationPageDetails) => {
    const { isPublic, domainName } = this.getPublicPagesContext();
    if (isPublic) {
      return `public-pages/${domainName}/${automationPageDetails.configuration_api_name}/execute`;
    }
    return `pageconfig/${automationPageDetails.id}/pages-config-execute`;
  }
  /** Rehydrate local formPayload from Redux params+response (breadcrumb return). */
  rehydrateFormPayloadFromPageRuntime = (
    outputResponse = {},
    inputParams = {}
  ) => {
    const merged = {
      ...(inputParams && typeof inputParams === "object" && !Array.isArray(inputParams)
        ? inputParams
        : {}),
      ...(outputResponse &&
      typeof outputResponse === "object" &&
      !Array.isArray(outputResponse)
        ? outputResponse
        : {}),
    };
    this.syncOutputResponseToFormPayload(merged);
  };

  componentDidMount = ()=>{
    const {pagesConfigData, bindPagesRenderApi} = this.props;
    if (typeof bindPagesRenderApi === "function") {
      bindPagesRenderApi({
        runPageAction: this.runPageAction,
      });
    }
    // Prefer params+response so Get Rates → back restores edited fields, not empty response.
    this.rehydrateFormPayloadFromPageRuntime(
      this.props.outputResponse,
      this.props.inputParams
    );
    if(pagesConfigData!==null){
        this.fetchVariablesList();
    }
  }
  componentWillUnmount = () => {
    const { bindPagesRenderApi } = this.props;
    if (typeof bindPagesRenderApi === "function") {
      bindPagesRenderApi(null);
    }
  };

  componentDidUpdate = (prevProps)=>{
    if (prevProps.bindPagesRenderApi !== this.props.bindPagesRenderApi && typeof this.props.bindPagesRenderApi === "function") {
      this.props.bindPagesRenderApi({
        runPageAction: this.runPageAction,
      });
    }
     const {pagesConfigData, outputResponse, inputParams} = this.props;
    if (
      prevProps.outputResponse !== outputResponse ||
      prevProps.inputParams !== inputParams
    ) {
      this.rehydrateFormPayloadFromPageRuntime(outputResponse, inputParams);
    }
    if(pagesConfigData!==null && prevProps.pagesConfigData?.id!==pagesConfigData?.id){
        this.fetchVariablesList();
    }
    // Feature flags always attach a pages object, so pages==null never matches.
    // Re-run onload automation on a direct route/reload only when there is no markup.
    // A page that already has html (menu open, form pages) must not execute again.
    const pageHtml = pagesConfigData?.pages?.html;
    const hasRenderablePage = isSet(pageHtml, null) !== null && String(pageHtml).trim() !== '';
    if(pagesConfigData!==null && prevProps.pagesConfigData?.id!==pagesConfigData?.id && hasRenderablePage===false && pagesConfigData?.config_type==='AUTOMATION'){
      this.onSubmitAutomationHandler(pagesConfigData?.configuration_api_name);
    }
  } 
 

  render() {
    const {composedHtml,pagesConfigData,resourcesList,pageFlows} = this.props;
    const { isbackgroundProcess } = this.state;
    
    // const valuesArray = Object.values(formPayload)
    return(
        <>
           {
           isbackgroundProcess && this.wrapperDom !== null &&
          createPortal(
            <BackgroundActionInputModal
              modelHandler={this.toggleBackgroundProcessModel}
              zIndex="2000"
            />,
            this.wrapperDom
          )
        }
        {composedHtml && (() => {
          const currentPageOutput = {
            ...(this.props.inputParams || {}),
            ...(this.props.outputResponse || {}),
          };
          // Get Rates markup needs shipObj / Package from this visit's pageFlows.
          // Other pages, including Add Shipment, show only their own params and
          // response so a prior rates snapshot is not painted onto the form.
          const displayResponse = isRatesResultsConfig(
            pagesConfigData?.configuration_api_name,
            pagesConfigData
          )
            ? ensureGetRatesMarkupOutputResponse(currentPageOutput, {
                pageFlows: this.props.pageFlows,
                fieldFormPayload: this.state.formPayload,
              })
            : currentPageOutput;
          return (
            <MarkupConversion 
                resourcesList={resourcesList['input']}
                windowVariableList={pageFlows?.windowVariableList}
                outputResponse={displayResponse}
                rateWithShipments={buildPagesRateWithShipmentsFromOutputResponse(
                  displayResponse
                )}
                // inputParams={this.props.inputParams}
                onSubmitAutomationHandler={this.onSubmitAutomationHandler}
                fieldFormPayload={this.state.formPayload}
                inputParams={this.props.inputParams}
                onChangeResourcesFieldHandler={(obj,val)=>this.fieldOnChangeHandler(obj,val)}
                onClearPagesFieldsHandler={this.clearPagesFieldsHandler}
                htmlContent={composedHtml} />
          );
        })()}
        </>
    )
  }
  fieldOnChangeHandler = (obj,val)=>{
    // const { pageFlows,  resourcesList} = this.props;
    // const automationPageDetails = pageFlows?.pageData[apiName];
    // const fromMapping = automationPageDetails?.from_page_mapping;
    // const toMapping = automationPageDetails?.to_page_mapping;
    // console.log('resourcesList',obj,fromMapping);
    // console.log("obj val ,",obj , val );
    // When HTML name (variable_name) and pages api_name differ only by casing
    // (Package vs package), keep both formPayload keys on the same selected_value
    // so subform UI and pages-config-execute mapping see the same rows/dims.
    const { resourcesList } = this.props;
    this.setState((prevState) => {
      const primary = obj.variable_name || obj.api_name;
      if (!primary) {
        return null;
      }
      const entry = {
        ...obj,
        selected_value: val,
      };
      const nextPayload = {
        ...prevState.formPayload,
        [primary]: entry,
      };
      const primaryLower = String(primary).toLowerCase();
      const resource = (resourcesList?.input || []).find((item) => {
        const api = String(item?.api_name || "").toLowerCase();
        const variable = String(item?.variable_name || "").toLowerCase();
        return api === primaryLower || variable === primaryLower;
      });
      if (resource) {
        [resource.api_name, resource.variable_name].filter(Boolean).forEach((key) => {
          if (key && key !== primary) {
            nextPayload[key] = {
              ...entry,
              api_name: resource.api_name || key,
              variable_name: resource.variable_name || key,
            };
          }
        });
      }
      return { formPayload: nextPayload };
    });
    // const inputMap = Object.fromEntries(
    //         resourcesList['input'].map(item => [item.id, obj.api_name])
    // );
    // console.log('inputMap',resourcesList,inputMap);
    // fromMapping.map(item => {
    //         // const apiName = inputMap[item.pages_variable_id];
    //         // const selectedValue = apiName ? formPayload[apiName]?.selected_value : undefined;
    //         return {
    //             ...item,
    //             selected_value: val
    //         };
    //     });
  }

  clearPagesFieldsHandler = (fieldNamesLower = []) => {
    const { resourcesList } = this.props;
    const inputs = isSet(resourcesList?.input, []);

    this.setState((prev) => {
      const nextPayload = { ...prev.formPayload };

      fieldNamesLower.forEach((labelLower) => {
        const resource = inputs.find((item) => {
          const varName = (item.variable_name || '').toLowerCase();
          const apiName = (item.api_name || '').toLowerCase();
          return varName === labelLower || apiName === labelLower;
        });

        const key =
          resource?.api_name ||
          resource?.variable_name ||
          Object.keys(nextPayload).find((k) => k.toLowerCase() === labelLower);

        if (!key) {
          return;
        }

        const existing = nextPayload[key] || resource || { api_name: key };
        nextPayload[key] = {
          ...existing,
          selected_value: '',
        };
      });

      return { formPayload: nextPayload };
    });
  };

  // Handle background modal submit with toEmail
  toggleBackgroundProcessModel = (data = {}, toFieldMapping = {}, backgroundParams = {}) => {
    if (Object.keys(backgroundParams).length > 0) {
      this.setState({
        isbackgroundProcess: false,
        toEmail: backgroundParams.toUserEmailIds,
        reminderAlert: backgroundParams.reminderAlert
      }, () => {
        this.executeAutomationWithEmail();
      });
    } else {
      // User cancelled modal
      this.setState({
        isbackgroundProcess: false,
        toEmail: null
      });
      this.props.Loader(false);
    }
  }

  // Store pending automation data
  storePendingAutomation = (automationPageDetails, updatePayload, fromMapping, toMapping) => {
    this.setState({
      pendingAutomation: {
        automationPageDetails,
        updatePayload,
        fromMapping,
        toMapping
      }
    });
  }

  // Execute automation with email parameter
  executeAutomationWithEmail = () => {
    this.props.Loader(true);
    const { pendingAutomation, toEmail, reminderAlert } = this.state;
    const { automationPageDetails, updatePayload, fromMapping, toMapping } = pendingAutomation || {};
  
    if (!automationPageDetails) {
      console.error('No automation found');
      this.props.Loader(false);
      return;
    }
    
    // Build URL with toEmail parameter
    let url = this.getExecuteUrl(automationPageDetails);
    if (toEmail) {
      url += `?toUserEmailIds=${toEmail}`;
      if (reminderAlert !== undefined) {
        url += `&reminderAlert=${reminderAlert}`;
      }
    }

    // console.log('Executing with URL:', url);
    this.executeAPI(automationPageDetails, updatePayload, fromMapping, toMapping, url,true);
  }

   executeAPI=(automationPageDetails, updatePayload, fromMapping, toMapping,url,isbackgroundProcess=false,isSamePage=false,params={})=>{
    try{
    this.props.Loader(true);
	  http.POST(url, updatePayload)
		.then(async (response) => {
      // Do not clear loader here: cross-page redirects (Get Rates) still need
      // fetchPageDetails GET + history.push. Clearing early paints Add Shipment.
			const responseData = response.data;
			if (responseData.code === 200) {
				const resData = responseData.data;
         if(isbackgroundProcess){
          this.props.Loader(false);
          this.props.removeActivePopupPageAction(this.props.currentPage);
          this.props.warningMessage(responseData.message)
          return
        }
        if (!resData) {
          this.props.Loader(false);
          // Collected with other page-open errors into one toast.
          if (responseData?.message) {
            this.props.failMessage(responseData.message);
          }
          return;
        }
				let outputResponse = {};
                // console.log('automationPageDetails',automationPageDetails?.automation_type==='API');
                let variables = isSet(resData.variables,[]);
                if(automationPageDetails?.automation_type==='API'){
                    // console.log('resData',resData);
                    isSet(resData,[]).forEach((rData)=>{
                        variables = [...variables,...isSet(rData.variables,[])];
                    })
                }
				try {
					variables.forEach((v) => {
						outputResponse = {
							...outputResponse,
							[isSet(v.api_name,v.apiName)]: v
						}
					});
				} catch (e) {}
                //  this.props.Loader(false);
                // console.log('variables',variables);
				let outputErrorMsg = outputResponse?.Error_messages?.value;
				// Save validation: show *_error inline only. Step is_execution_log returns
				// empty Info rows that were toasting a blank Error modal — skip those.
				const hasInlineFieldErrors = hasPagesInlineFieldErrors(outputResponse);
				if (!hasInlineFieldErrors) {
					const rawMessages = isSet(
						responseData.messages,
						isSet(outputErrorMsg, []),
						"ARRAY"
					);
					const usefulMessages = (Array.isArray(rawMessages) ? rawMessages : []).filter(
						(entry) => {
							if (entry == null) return false;
							if (typeof entry === "string") return entry.trim() !== "";
							const text =
								entry.message ??
								entry.Message ??
								entry.msg ??
								entry.value ??
								"";
							return String(text).trim() !== "" && String(text).toLowerCase() !== "null";
						}
					);
					if (usefulMessages.length > 0) {
						this.props.setErrorListAction(usefulMessages);
					}
				}
				const onBeforeNavigate = () => {
					if (this.props.pageType === 'POPUP') {
						this.props.removeActivePopupPageAction(this.props.currentPage);
					}
				};
				let isConditionTrue = false;
				const safeToMapping = orderToPageMappingForExecute(toMapping);
				for (let i = 0; i < safeToMapping.length; i++) {
					const toMap = safeToMapping[i];
					const isTrue = evaluatePagesMessageCondition(toMap?.condition, outputResponse);
					if (!isTrue) continue;
					isConditionTrue = true;
					if (isToPageRedirectMode(toMap)) {
						const didRedirect = resolveAndNavigateRedirect({
							redirectConfig: toMap.redirect,
							variables,
							history: this.props.history,
							onBeforeNavigate,
						});
						if (didRedirect) {
							this.props.Loader(false);
							return;
						}
						// Condition matched but DETAIL/EDIT URL unresolved (e.g. null
						// record id after create validation fail) — stay on page.
						this.props.Loader(false);
						if (hasPagesInlineFieldErrors(outputResponse)) {
							this.emitPagesValidationFeedback(outputResponse);
						}
						break;
					}
					const valuesArray = variables;
					let toFieldMapping = isSet(toMap?.field_mappings, []).map((mField) => ({
						...mField,
						value: resolveMappedVariableValue(mField, valuesArray),
					}));
					let toFieldMappingOutputs = {};
					let pageId = toMap?.page_id;
					const getRatesRedirect = isGetRatesPageRedirectTarget(toMap, pageId);
					const effectiveSamePage = isEffectiveSamePageResult({
						automationPageDetails,
						hostPagesConfig: this.props.pagesConfigData,
						toMap,
						getRatesRedirect,
					});
					if (getRatesRedirect) {
						const ratesKeys = collectRatesResultsPageDataKeys(
							this.props.pageFlows
						);
						const targetApi = resolvePagesRedirectTargetConfigApiName(
							toMap,
							pageId
						);
						if (targetApi) {
							ratesKeys.push(String(targetApi));
						}
						if (ratesKeys.length > 0) {
							this.props.resetPagesRuntimeCacheAction({
								configKeys: [...new Set(ratesKeys)],
							});
						}
					}
					const mappedExecuteOutputs = normalizePagesGetRatesRedirectOutputs(
						buildPagesRedirectFieldOutputs(toFieldMapping, updatePayload),
						{ hyperthreadVariables: variables }
					);
					// Same-page: mapped outputs only — never merge prior pageFlows/form
					// (prefer-rich kept longer Package / non-empty services across re-runs).
					// Get Rates redirect still merges host context for display continuity.
					try {
						toFieldMappingOutputs = ensureGetRatesMarkupOutputResponse(
							mappedExecuteOutputs,
							effectiveSamePage
								? { hyperthreadVariables: variables }
								: {
										hyperthreadVariables: variables,
										pageFlows: this.props.pageFlows,
										fieldFormPayload: this.state.formPayload,
								  }
						);
					} catch (e) {
						console.error("Get Rates redirect output mapping failed", e);
						toFieldMappingOutputs = ensureGetRatesMarkupOutputResponse(
							effectiveSamePage ? mappedExecuteOutputs : {},
							effectiveSamePage
								? { hyperthreadVariables: variables }
								: {
										hyperthreadVariables: variables,
										pageFlows: this.props.pageFlows,
										fieldFormPayload: this.state.formPayload,
								  }
						);
					}
					persistGetRatesExecuteResponse(toFieldMappingOutputs);
					if (!isbackgroundProcess) {
						if (effectiveSamePage) {
							pageId = this.props.pagesConfigData?.pages?.id;
						}
						// Cross-page: toMap → Tracking_disply_page / Get_rates_config. Avoid automation
						// api_name (tracking_lookup) as Redux/route key when navigating to another page.
						const redirectConfigApiName = effectiveSamePage
              ? automationPageDetails?.configuration_api_name
              : resolvePagesRedirectTargetConfigApiName(toMap, pageId);
						this.fetchPageDetails(
              pageId,
              redirectConfigApiName ||
                automationPageDetails?.configuration_api_name,
              toFieldMappingOutputs,
              params,
              effectiveSamePage
            );
					}
					break;
				}
				if (isConditionTrue === false) {
					this.props.Loader(false);
					if (hasPagesInlineFieldErrors(outputResponse)) {
						this.emitPagesValidationFeedback(outputResponse);
					}
				}

				// console.log('outputResponse',JSON.stringify(outputResponse));

			} else if (responseData.message) {
				this.props.Loader(false);
				this.props.failMessage(responseData.message);
			} else {
				this.props.Loader(false);
				this.props.failMessage("Page automation failed. Please try again.");
			}
		}, (error) => {
      this.props.Loader(false);
			console.log(error);
			this.props.failMessage(
				resolvePagesHttpErrorMessage(
					error,
					"Page automation request failed. Please try again."
				)
			);
		})  
    } catch (error) {
      console.error("Error in executeAPI:", error);
      this.props.Loader(false);
      this.props.failMessage(
        resolvePagesHttpErrorMessage(
          error,
          "Page automation request failed. Please try again."
        )
      );
    }
   }
  onSubmitAutomationHandler = async (apiName, params = {}) => {
    try {
      const { formPayload } = this.state;
      const { pageFlows, resourcesList } = this.props;
      const { isPublic } = this.getPublicPagesContext();
      let automationPageDetails = pageFlows?.pageData[apiName];
      const formFlat = flattenFormPayloadForPagesExecute(formPayload);
      const mergedParams = buildMergedPagesExecuteParams({
        pageFlows,
        automationApiName: apiName,
        params: { ...(this.props.inputParams || {}), ...formFlat, ...params },
        fieldFormPayload: formPayload,
        inputParams: this.props.inputParams,
        outputResponse: this.props.outputResponse,
        resolveHostConfig: resolveSamePageHostConfig,
      });

      const fromMapping = isSet(automationPageDetails?.from_page_mapping, []);
      const toMapping = isSet(automationPageDetails?.to_page_mapping, []);
      const isSamePage = resolveIsSamePageAutomation(
        automationPageDetails,
        this.props.pagesConfigData
      );
      const isbackgroundProcess = isSamePage
        ? false
        : automationPageDetails?.is_background_process;

      if (!isPublic && automationPageDetails?.id) {
        try {
          const hasPermission =
            await ProfileService.checkPagesConfigurationPermission(
              automationPageDetails.id
            );
          if (!hasPermission) {
            if (typeof this.props?.warningMessage === "function") {
              this.props.warningMessage(
                "You don't have permission to access this page. Please contact your administrator."
              );
            }
            this.props.Loader(false);
            return;
          }
        } catch (permissionError) {
          console.error("Permission check failed:", permissionError);
          this.props.Loader(false);
          return;
        }
      }

      this.setState({
        isbackgroundProcess: isbackgroundProcess,
      });

      const url = this.getExecuteUrl(automationPageDetails);
      const { configKey: hostConfigKey, pages: hostPages } =
        resolveSamePageHostConfig(pageFlows, apiName);
      // Persist live form into host pageData before Get Rates redirect so breadcrumb
      // remount can rehydrate formPayload from params/response (not empty state).
      if (hostConfigKey && hostPages?.html) {
        this.props.updatePageDataByKeyAction(hostConfigKey, "pages", {
          ...hostPages,
          params: {
            ...omitEphemeralPagesParams(hostPages.params || {}),
            ...omitEphemeralPagesParams(mergedParams),
          },
          response: {
            ...(hostPages.response || {}),
            ...formFlat,
          },
        });
      }
      const updatePayload = wrapPagesConfigExecutePayload(
        buildPagesConfigExecutePayload({
          fromMapping,
          resourcesList,
          automationType: automationPageDetails?.automation_type,
          formPayload,
          params: mergedParams,
        }),
        mergedParams
      );

      if (isbackgroundProcess) {
        this.props.Loader(false);
        this.storePendingAutomation(
          automationPageDetails,
          updatePayload,
          fromMapping,
          toMapping
        );
        return;
      }

      this.props.Loader(true);
      this.executeAPI(
        automationPageDetails,
        updatePayload,
        fromMapping,
        toMapping,
        url,
        isbackgroundProcess,
        isSamePage,
        mergedParams
      );
    } catch (error) {
      console.error("Error in onSubmitAutomationHandler:", error);
      this.props.Loader(false);
    }
  };

   fetchVariablesList = () => {
        const {pagesConfigData} = this.props;
        // console.log('fetchVariablesList',pagesConfigData);
        if(isSet(pagesConfigData.id,null)===null){
           return false;
        }
        // console.log('pageData',pageData);
        // let automationType = pageData.automation_type;
        // if(pageData.automation_type==='RATINGS'){
        //     automationType = 'HYPERTHREAD';
        // }
        // this.setState({
        //   isMappingDDLoading:true
        // })
        const { isPublic, domainName } = this.getPublicPagesContext();
        const configApiName = pagesConfigData?.configuration_api_name;
        if (isPublic && !configApiName) {
          return;
        }
        const variablesUrl = isPublic
          ? `public-pages/${domainName}/${configApiName}/pages-variable/paginated-search?pageConfigurationId=${pagesConfigData.id}&search=&page=0&orderBy=&size=1000`
          : `pages-variable/paginated-search?pageConfigurationId=${pagesConfigData.id}&search=&page=0&orderBy=&size=1000`;
        http.GET(variablesUrl)
            .then(async (response) => {
            //    this.setState({
            //     isMappingDDLoading:false
            //   })
                // console.log('response',response);
                const responseData = response.data;
                if (responseData.code === 200) {
                    const data = responseData.data;
                    let inputVariables = [];
                    let outputVariables = [];
                    // isSet(data, []).map((item) => {
                    //   if(automationType==='STEPS'){
                    //      inputVariables.push({...item,fields:[]});
                    //      outputVariables.push({...item,fields:[]});
                    //   }else{
                    //     if(item.is_request===true){
                    //         // if (item.fieldtype_name === 'Object' || item.fieldtype_name === 'Array' || item.fieldtype_name === 'Messages') {
                    //         //     item.fields = [];
                    //         // }
                    //         inputVariables.push({...item,fields:[]});
                    //     }else if(item.is_response===true){
                    //         outputVariables.push({...item,fields:[]});
                    //     }
                    //   }
                        
                    //         // global_variables.push(item);
                    // });
                    // console.log(" responses-==" , inputVariables);
                    //  this.props.setResourcesListAction({
                    //     variables: data,
                    //     input:inputVariables,
                    //     output:outputVariables
                    // });

                    // isSet(global_variables, []).map((item) => {
                        // if (isSet(item.window_id, null) !== null) {
                        //     generateWindowFields(item.window_id);
                        // }
                        // if (item.fieldtype_name === 'Object' || item.fieldtype_name === 'Array' || item.fieldtype_name === 'Messages') {
                        //     fetchArrayObjectVariables(item);
                        // }
                    // })

                }else{
                  
                    // this.props.setResourcesListAction({
                    //     variables: [],
                    //     input:[],
                    //     output:[]
                    // });
                }
            }, (error) => {
                console.log(error);
                //  this.setState({
                //   isMappingDDLoading:false
                // })
            })

    }

    applySamePageResponseUpdate = (configApiName, toFieldMapping, params = {}) => {
        if (isRatesResultsConfig(configApiName, this.props.pageFlows?.pageData?.[configApiName])) {
          return false;
        }
        const safeParams =
          params && typeof params === "object" && !Array.isArray(params) ? params : {};
        const { configKey, pages: hostPages } = resolveSamePageHostConfig(
          this.props.pageFlows,
          configApiName
        );
        const existingPages = hostPages?.html ? hostPages : this.props.pagesConfigData?.pages;
        if (!existingPages?.html) {
          return false;
        }
        const resolvedKey =
          configKey ||
          this.props.currentPage ||
          this.props.pagesConfigData?.configuration_api_name ||
          configApiName;
        if (!resolvedKey) {
          return false;
        }
        this.props.Loader(false);
        // Same-page: do NOT merge prior pageFlows/form via Get Rates prefer-rich.
        // That kept longer Package / non-empty services across re-executes.
        // Only this execute's To Mapping keys replace (mapping-driven).
        const executeOutputs = normalizePagesGetRatesRedirectOutputs(
          toFieldMapping || {}
        );
        const enrichedOutputs = ensureGetRatesMarkupOutputResponse(
          executeOutputs,
          {}
        );
        const priorResponse =
          (existingPages.response &&
          typeof existingPages.response === "object" &&
          !Array.isArray(existingPages.response)
            ? existingPages.response
            : null) ||
          (this.props.outputResponse &&
          typeof this.props.outputResponse === "object" &&
          !Array.isArray(this.props.outputResponse)
            ? this.props.outputResponse
            : {});
        const normalizedResponse = mergeSamePageExecuteOutputs(
          priorResponse,
          enrichedOutputs
        );
        persistGetRatesExecuteResponse(normalizedResponse);
        const nextParams = applyMappedExecuteOutputsToParams(
          {
            ...omitEphemeralPagesParams(this.props.inputParams || {}),
            ...omitEphemeralPagesParams(safeParams),
          },
          enrichedOutputs
        );
        this.props.updatePageDataByKeyAction(resolvedKey, 'pages', {
          ...existingPages,
          params: nextParams,
          response: normalizedResponse
        });
        // Sync only this execute's mapped keys so unmapped form edits survive,
        // while mapped arrays/scalars (incl. []) fully replace.
        this.syncOutputResponseToFormPayload(enrichedOutputs);
        this.emitPagesValidationFeedback(normalizedResponse);
        return true;
    }

    fetchPageDetails = (pageId,configApiName,toFieldMapping,params = {}, isSamePage = false)=>{
        if (isSamePage && this.applySamePageResponseUpdate(configApiName, toFieldMapping, params)) {
          return;
        }
         if (!pageId) {
           this.props.Loader(false);
           return;
         }
         const { isPublic, domainName } = this.getPublicPagesContext();
         const pagesQuery = this.getPublicPagesQuery();
         const pagesWindowQuery = this.getPagesWindowQuery();
         const pageDetailsUrl = isPublic
           ? `public-pages/${domainName}/${configApiName}/pages/search-by-id/${pageId}`
           : `pages/search-by-id/${pageId}`;
         http.GET(pageDetailsUrl)
            .then(async (res) => {
                // Keep loader until after hydrate + history.push so Add Shipment
                // does not paint uncovered between GET complete and route change.
                const clearLoaderAfterNav = () => {
                  setTimeout(() => this.props.Loader(false), 0);
                };
                if (res.status === 200) {
                    const response = res.data;
                    if (response.code === 200) {
                        const resData = response?.data;
                        const targetConfigKey = resolvePagesTargetConfigKey(
                          resData,
                          configApiName,
                          pageId
                        );
                        const safeParams =
                          params && typeof params === "object" && !Array.isArray(params) ? params : {};
                        let shouldNavigateSameWindow = false;
                        if(resData?.display_type==='SAME_WINDOW'){
                                if (!isSamePage) {
                                  this.props.setPagesHistoryConfigAction();
                                }
                                shouldNavigateSameWindow = true;
                             if(this.props.pageType==='POPUP'){
                                this.props.removeActivePopupPageAction(this.props.currentPage);
                             }
                        }else if(resData?.display_type==='SEPARATE_WINDOW'){
                          // Use configApiName if available (from parameter), otherwise fall back to id
                          // const urlIdentifier = resData?.id;
                          const url = `/pages/${targetConfigKey}${pagesWindowQuery}`;
                          const {format,width,height} = resData;
                          let screenwidth;
                          let screenheight;
                          let topPosition = 100;
                          let leftPosition = 100;

                          if (format === "CUSTOM") {
                            screenwidth = width;
                            screenheight = height;
                          } else {
                            screenwidth = window.screen.availWidth;
                            screenheight = window.screen.availHeight;
                          }

                          if (window.opener) { window.close(); }
                          const windowFeature = `width=${screenwidth},height=${screenheight},top=${topPosition},left=${leftPosition},resizable=no,scrollbars=yes,location=no,status=no`;

                          const forceResize = (win) => {
                            if (!win || win.closed) return;
                            try {
                              win.resizeTo(screenwidth, screenheight);
                              win.focus();
                            } catch (e) {
                              console.error('Error resizing window:', e);
                            }
                          };

                          if (window.childWindow && !window.childWindow.closed) {
                            try {
                              window.childWindow.location.href = url;
                              forceResize(window.childWindow);
                            } catch (e) {
                              console.error('Error updating child window:', e);
                              window.childWindow = window.open(url, resData.page_name, windowFeature);
                            }
                          } else {
                            window.childWindow = window.open(
                              url,
                              resData.page_name,
                              windowFeature
                            );
                            if (!window.childWindow || window.childWindow.closed) {
                              console.error('Failed to open child window - may be blocked by popup blocker');
                              this.props.Loader(false);
                            }
                          }
                          this.props.setPagesHistoryConfigAction();
            
                        }else{
                            this.props.removeActivePopupPageAction(this.props.currentPage);
                        }
                        
                       
                       
                        const normalizedResponse = ensureGetRatesMarkupOutputResponse(
                          toFieldMapping || {},
                          {
                            pageFlows: this.props.pageFlows,
                            fieldFormPayload: this.state.formPayload,
                          }
                        );
                        persistGetRatesExecuteResponse(normalizedResponse);
                        const pagesPayload = {
                          ...response?.data,
                          params: safeParams,
                          response: normalizedResponse,
                        };
                        this.props.loadPageConfigCollectionAction(
                          {
                            configuration_api_name: targetConfigKey,
                            pages: pagesPayload,
                            type: "PAGES",
                          },
                          "ID",
                          targetConfigKey
                        );
                        this.props.updatePageDataByKeyAction(
                          targetConfigKey,
                          "pages",
                          pagesPayload
                        );
                        if (shouldNavigateSameWindow) {
                          const targetPath = `/pages/${targetConfigKey}${pagesQuery}`;
                          const currentFull = `${this.props.history?.location?.pathname || ''}${this.props.history?.location?.search || ''}`;
                          if (currentFull !== targetPath) {
                            this.props.history.push(targetPath);
                          }
                        }
                        clearLoaderAfterNav();
                        // console.log('response',response?.data,toFieldMapping);
                        // this.props.updatePageFlowsDataAction(configApiName,'toOutputPages',{
                        //     pages:response?.data,
                        //     outputVariables:toFieldMapping
                        // });
                        // this.setState({ pageConfigData: response.data });
                    } else {
                        this.props.Loader(false);
                        // this.props.failMessage(response.message);
                    }
                } else {
                    this.props.Loader(false);
                }
            }, (error) => {
                this.props.Loader(false);
                // this.props.failMessage('Error occured while save profile');
            })
    }
}


const mapDispatchToProps = dispatch => {
    return {
        Loader: (bool) => dispatch(actions.loader(bool)),
        succMessage: (msg) => dispatch(actions.succMessage(msg)),
        failMessage: (msg) => dispatch(actions.failMessage(msg)),
        warningMessage: (msg) => dispatch(actions.warningMessage(msg)),
        setErrorListAction:(val)=>dispatch(setErrorListAction(val)),
        updatePageFlowsDataAction:(a,b,c)=>dispatch(updatePageFlowsDataAction(a,b,c)),
        loadPageConfigCollectionAction:(by,val,history)=>dispatch(loadPageConfigCollectionAction(by,val,history)),
        updatePageDataByKeyAction:(a,b,c)=>dispatch(updatePageDataByKeyAction(a,b,c)),
        removeActivePopupPageAction:(payload)=>dispatch(removeActivePopupPageAction(payload)),
        setPagesHistoryConfigAction:()=>dispatch(setPagesHistoryConfigAction()),
        resetPagesRuntimeCacheAction:(payload)=>dispatch(resetPagesRuntimeCacheAction(payload)),
        // clearPagesConfiguration:()=>dispatch(clearPagesConfiguration())
    };
}
const mapStateToProps = (state) => { 
  return {
    //   fromMappingFields:state.PagesReducer.pagesConfiguration.from_page_mapping,
      resourcesList:state.PagesReducer.resourcesList,
      activePage:state.PagesReducer.activePage,
      pageFlows:state.PagesReducer.pageFlows,
  };
}
export default
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(withRouter(PagesRenderComponent));
